var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex gap-x-2 font-bold items-center",class:[_vm.getJustification()],on:{"click":_vm.click}},[_c('div',{staticClass:"hover:underline"},[_vm._t("default")],2),_vm._v(" "),_c('div',[_c('v-icon',{attrs:{"name":_vm.iconNames[_vm.sortByDirection]}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }